import { render, staticRenderFns } from "./TokensPage.vue?vue&type=template&id=f1b6f140&scoped=true"
import script from "./TokensPage.vue?vue&type=script&lang=js"
export * from "./TokensPage.vue?vue&type=script&lang=js"
import style0 from "./TokensPage.vue?vue&type=style&index=0&id=f1b6f140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b6f140",
  null
  
)

export default component.exports